import React, { useRef } from "react";

const GlareHover = ({
  width = "100%",
  height = "100%",
  background = "transparent",
  borderRadius = "16px",
  borderColor = "rgba(255,255,255,0.1)",
  children,
  glareColor = "#ffffff",
  glareOpacity = 0.25,
  glareAngle = -45,
  glareSize = 180,
  transitionDuration = 500,
  exitDuration = 180,
  className = "",
  style = {},
}) => {
  const ref = useRef(null);
  const frame = useRef(null);

  const getRgba = (hexColor, opacity) => {
    const cleanHex = hexColor.replace("#", "");

    const r = parseInt(cleanHex.slice(0, 2), 16);
    const g = parseInt(cleanHex.slice(2, 4), 16);
    const b = parseInt(cleanHex.slice(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };

  const rgba = getRgba(glareColor, glareOpacity);

  const updatePosition = (e) => {
    if (!ref.current) return;

    const rect = ref.current.getBoundingClientRect();

    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;

    ref.current.style.setProperty("--x", `${x}%`);
    ref.current.style.setProperty("--y", `${y}%`);
  };

  const handleMove = (e) => {
    if (frame.current) cancelAnimationFrame(frame.current);

    frame.current = requestAnimationFrame(() => {
      updatePosition(e);
    });
  };

  return (
    <div
      ref={ref}
      className={`glare-card ${className}`}
      onMouseMove={handleMove}
      style={{
        width,
        height,
        background,
        borderRadius,
        border: `1px solid ${borderColor}`,
        position: "relative",
        overflow: "hidden",
        willChange: "transform",
        transform: "translateZ(0)",
        ...style,
      }}
    >
      <div className="glare-layer" />

      <div className="relative z-[2] h-full">{children}</div>

      <style>{`
        .glare-card {
          --x: -100%;
          --y: -100%;
        }

        .glare-layer {
          position: absolute;
          inset: 0;
          pointer-events: none;

          background:
            radial-gradient(
              circle at var(--x) var(--y),
              ${rgba} 0%,
              transparent 35%
            );

          opacity: 0;
          transition:
            opacity ${transitionDuration}ms ease,
            background-position ${transitionDuration}ms ease;

          will-change: opacity, transform;
        }

        .glare-card:hover .glare-layer {
          opacity: 1;
        }

        .glare-card:not(:hover) .glare-layer {
          transition-duration: ${exitDuration}ms;
        }
      `}</style>
    </div>
  );
};

export default GlareHover;
